const firebaseConfig = {
  apiKey: "AIzaSyAtY8djOUJhZXh2TTntLSY9pGouFfsy3WY",
  authDomain: "appartmenthunt-740eb.firebaseapp.com",
  projectId: "appartmenthunt-740eb",
  storageBucket: "appartmenthunt-740eb.appspot.com",
  messagingSenderId: "1037021867344",
  appId: "1:1037021867344:web:2a38f24acb283759d69055"
};
export default firebaseConfig;
